"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.edieTemplateTypes = exports.edie2htmlProcessors = exports.contentTypes = void 0;
exports.contentTypes = {
    pdf: 'application/pdf',
    html: 'text/html',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
exports.edie2htmlProcessors = ["edie", "handlebars", "mjml"];
exports.edieTemplateTypes = ['xemail', 'xdoc'];
//# sourceMappingURL=constants.js.map